export const OPEN_MODAL_DIALOG = 'OPEN_MODAL_DIALOG';
export const CLOSE_MODAL_DIALOG = 'CLOSE_MODAL_DIALOG';

export const openModalDialog = () => ({
    type: OPEN_MODAL_DIALOG,
});

export const closeModalDialog = () => ({
    type: CLOSE_MODAL_DIALOG,
});
